/**
 * 救援价格维护
 * 创建时间：2017-08-18
 * 创建人：baixx
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="rescueprice-list">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">	   	
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">救援公司</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="organise">
						<option v-for="item in organiseArr" :value="item.id">{{item.groupName}}</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-3">
					<div class="form-group pt5px mr40px" style="margin-left:55px;">
						<label>拖车里程价格关系维护:</label>
					</div>
				</div>
				<div class="col-sm-2">
					<div class="pl50px mt5px">
						<checkbox v-model="includingCheck">截至公里数包含在内</checkbox>
					</div>
				</div>  
				<span class="col-sm-2 control-label">超出基本公里数后，按</span>
				<div class="col-sm-1">
					<input type="text" class="form-control" v-model="maxPrice" maxlength="20">
				</div> 
				<span class="col-sm-1 control-label gray t_left">元/公里计价</span>
			</div> 
			<div class="form-group">
				<div style="padding-right: 75px;" class="col-sm-12 text-right">
					<button type="button" class="btn btn-primary" @click="addMileagePrice">新增里程价格关系</button>
				</div>
			</div>
		</div>
		<!--表格开始-->
		<!--<table class="table mb0px table-striped table-bordered table-hover" style="min-width:1600px;">-->
		<table style="width:92%;" align="center" class="table mt20px table-striped table-bordered">
			<thead>
				<tr>
					<th style="width:6%"></th>
					<th style="width:15%" class="text-center red">*起始公里数</th>
					<th style="width:15%" class="text-center red">*截止公里数</th>
					<th style="width:10%" class="text-center red">*价格(元)</th>
					<th class="text-center">备注</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in mileageTrailers" v-bind:key="index">
					<td class="text-center" @click="deleteMessage(index)">
						<a class="glyphicon glyphicon-trash"></a>
					</td>
					<td><input type="text" class="form-control text-center" v-model="fileInfo.startMileage"></td>
					<td><input type="text" class="form-control text-center" v-model="fileInfo.endMileage"></td>
					<td><input type="text" class="form-control text-center" v-model="fileInfo.price"></td>
					<td><input type="text" class="form-control text-center" v-model="fileInfo.memo"></td>
				</tr>
			</tbody>
		</table>
	    <br/>
		<span style="margin-left:50px;">注：1、各公里数区间必须连续，不能出现空挡。</span>
		<br/>
		<span style="margin-left:77px;">2、超出最大的截止公里数后，按每公里X元计价。</span>
		<br/>
		<br/>
		
		<div class="form-horizontal pt10px">			
			<div class="form-group">
				<div class="col-sm-3">
					<div class="form-group pt5px mr40px" style="margin-left:55px;">
						<label>拖车以外按次计价的价格关系维护：</label>
					</div>
				</div>
				<span class="col-sm-1 control-label">放空任务按</span>
				<div class="col-sm-1">
					<input type="text" class="form-control" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" v-model="emptyPriceRatio">
				</div> 
				<span class="col-sm-1 control-label gray t_left">%计价</span>
			</div> 
		</div>	
		<!--<label style="margin-left:55px;">拖车以外按次计价的价格关系维护：</label>-->
		<!--表格开始-->
		<table style="width:92%;" align="center" class="table mt20px table-striped table-bordered text-center">
			<thead>
				<tr>
					<th style="width:15%" class="text-center">项目名称</th>
					<th style="width:15%" class="text-center red">*价格(元)</th>
					<th class="text-center">备注</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in outsideTrailers" v-bind:key="index">
					<td class="text-center" v-show="fileInfo.rescueType!=4">{{setRescurStatus(fileInfo.rescueType)}}</td>
					<td v-show="fileInfo.rescueType!=4"><input type="text" class="form-control text-center" v-model="fileInfo.price"></td>
					<td v-show="fileInfo.rescueType!=4"><input type="text" class="form-control text-center" v-model="fileInfo.memo"></td>
				</tr>
			</tbody>
		</table>
		</br>
		<div class="form-group">
			<div class="col-sm-12 text-center">
				<button type="button" class="btn btn-primary" @click="saveRescueOrder">保存</button>
			</div>
		</div>
		</br>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>	
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import { maxLength } from 'vuelidate/lib/validators'
	import Checkbox from 'components/common/Checkbox' 
	export default {
		name: "PageRescuePriceList",
		components: {
			Pagination,
			Datepicker,
			TabModal,
			Checkbox,
		},
		data() {
			return {
				loadingstatus:false,
				organise:'',
				organiseArr:[],                                         //组织机构信息
				customerId:"",
				showSubPage: false,
				includingCheck:false,                                            
				including:'',                                            //包含截至公里数在内
				maxPrice:'',                                             //超出的价格
				mileageTrailers:[],                                      //拖车里程价格维护
				emptyPriceRatio:50,                                      //放空价格比例
				outsideTrailers:[],                                      //拖车以外的价格维护列表
				messageStr: "",					                        // 弹出框内容
				scrollTop: '',
				isDetailMode:false,
				isShow:false,
				outsideTrailers:[
					{rescueType:2,price:"",memo:""},
					{rescueType:3,price:"",memo:""},
					{rescueType:4,price:"",memo:""}
				]
			};
		},
		watch:{
			'organise'(val){
				this.organise = val;
				if(val){
					this.getTableInfo();
				}
			},
		},
		beforeMount() {
			//获得组织机构信息
			this.getOrganise();
			//this.getTableInfo();
		},
		methods: {
			setRescurStatus(value){
				if(value=='2'){
					return '搭电'
				}else if(value=='3'){
					return '换胎'
				}
			},
			//新增价格里程关系
			addMileagePrice(){
				if(this.mileageTrailers.length<7){
					let instr = {};
		 			instr.endMileage = null
		 			instr.memo = ""
		 			instr.price = null
		 			instr.startMileage = null
					this.mileageTrailers.push(instr);
				}else{
					this.openModalMsg("里程价格最多可建7个");
				}
			},
			//获得组织机构信息
			getOrganise(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/account/customer/fleet')
					.then( res => {
						this.organiseArr = res.body.data
						if(res.body.data.length!=0){
							for(var i = 0; i < this.organiseArr.length; i++) {
							    this.organise = this.organiseArr[0].id
							}
							if(this.organiseArr[0].id){
								this.getTableInfo();
							}
						}
						this.loadingstatus = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			// 获取列表信息
			getTableInfo() { 
				this.loadingstatus = true;
				let parm = {
					customerId :this.organise
				}
				//this.$http.get('/mockjs/41/rescue/service/price')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/service/price',{params:parm})
					.then( res => {
						this.including = res.body.data.including
						if(this.including ==1){
							this.includingCheck = true
						}else{
							this.includingCheck = false
						}
						this.maxPrice = res.body.data.maxPrice
						this.emptyPriceRatio = res.body.data.emptyPriceRatio/100;
                        //拖车公里价格维护
						this.mileageTrailers = res.body.data.trailerPriceList;
						//拖车以外的价格维护信息
						this.outsideTrailers = res.body.data.otherPriceList;
						this.loadingstatus = false;
					}, res => {
						this.including = 0;
						this.includingCheck = false
						this.maxPrice = '';
                        //拖车公里价格维护
						this.mileageTrailers = [];
						for(var i = 0; i < this.outsideTrailers.length; i++) {
							this.outsideTrailers[i].price = '';
							this.outsideTrailers[i].memo = '';
						}
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			 compare (prop) {
			    return function (obj1, obj2) {
			        var val1 = obj1[prop];
			        var val2 = obj2[prop];
			        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
			            val1 = Number(val1);
			            val2 = Number(val2);
			        }
			        if (val1 < val2) {
			            return -1;
			        } else if (val1 > val2) {
			            return 1;
			        } else {
			            return 0;
			        }            
			    } 
			},
			//保存
			saveRescueOrder(){
				let arr = [];
				arr = Object.assign([],this.mileageTrailers);
				arr.sort(this.compare("startMileage"))
				for(var i = 0; i < arr.length; i++) {
					if(parseInt(arr[i].startMileage) >= parseInt(arr[i].endMileage)) {
						this.openModalMsg("起始公里数应小于截止公里数");
							return;
						}
					if( i<=arr.length-2 ){
						if(arr[i].endMileage!=arr[i+1].startMileage) {
							this.openModalMsg("请输入连续公里数");
							return;
						}
					}
				}
				if(this.includingCheck){
					this.including = 1
				}else{
					this.including = 0
				}
				if(this.emptyPriceRatio >100){
					this.openModalMsg("放空比例不能超过100");
					return;
				}
				let emptyPriceRatio = this.emptyPriceRatio*100
			    const para = {
			    	including:this.including,
			    	maxPrice:this.maxPrice,
			    	emptyPriceRatio:emptyPriceRatio,
					otherPriceList:this.outsideTrailers,
					trailerPriceList:arr,
					customerId :this.organise
				}
			    this.loadingstatus = true;
			   // this.$http.post('/mockjs/41/rescue/service/price?otherPriceList=&trailerPriceList=&maxPrice=&including=')
			     
				this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/service/price',para)
					.then(res => {
						if(res.data.success) {
							this.openModalMsg("保存成功");
						} else {
							this.openModalMsg(res.data.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.loadingstatus = false;
						this.openModalMsg(res.data.message);
					}).catch(res => {
						this.loadingstatus = false;
						this.openModalMsg(OPERATE_EXCEPTION);
				}) 
			},
			// 拖车里程价格维护删除
			deleteMessage(index){
				this.mileageTrailers.splice(index, 1);
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#rescueprice-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#rescueprice-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	}
		}
	}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// PageRescuePriceList.vue?49d1bccc